import React from 'react';
import { motion } from 'framer-motion';
import { 
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { faqs, whatsappNumber, whatsappMessage } from '../../data/mock';

const FAQ = () => {
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section id="faq" className="py-20 lg:py-28 px-4" style={{ background: 'var(--bg-page)' }}>
      <div className="container mx-auto max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <span className="section-tag">FAQ</span>
          <h2 className="heading-1 mb-4">
            Perguntas frequentes
          </h2>
          <p className="body-large max-w-2xl mx-auto">
            Tire suas dúvidas sobre nossa solução de automação
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-[var(--bg-card)] rounded-2xl border border-[var(--border-light)] px-6 overflow-hidden data-[state=open]:border-[var(--brand-primary)] transition-colors"
              >
                <AccordionTrigger className="text-left font-semibold text-[var(--text-primary)] hover:text-[var(--brand-primary)] py-5 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[var(--text-secondary)] pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center mt-12"
        >
          <p className="text-[var(--text-secondary)] mb-4">
            Ainda tem dúvidas? Fale com nossa equipe!
          </p>
          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-whatsapp inline-flex"
          >
            Falar no WhatsApp
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
